import Q3AnimationMixer from "../animations/animationMixer";

function initAnimation() {
    Q3.mixer = new Q3AnimationMixer();
}

export { initAnimation };